// extracted by mini-css-extract-plugin
export var errorsContainer = "_rj-1";
export var link = "_rj-0";